import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=51ae0314"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports